/**
 * Module-scoped fast path for reading the AUI-managed remote thread id
 * without depending on React render cycles. Extracted into its own module
 * to avoid circular imports between assistant.tsx ↔ praetorAttachmentAdapter.
 *
 * Writer: AuiThreadIdBridge component (in customThreadListProvider.tsx)
 * Readers: chatModelAdapter (waitForInitializedThreadId), praetorAttachmentAdapter (waitForThreadId)
 */

let _auiRemoteThreadId: string | undefined;

export const getAuiRemoteThreadId = (): string | undefined =>
  _auiRemoteThreadId;

export const setAuiRemoteThreadId = (id: string | undefined): void => {
  _auiRemoteThreadId = id;
};
